import formConsulta from "@/components/consultas/formConsulta/formConsulta.vue";

export default {
	name: "Error",

	components: {
		formConsulta,
	},
	data() {
		return {
			abrirNovaConsulta: {
				intOpcao: 0,
				strAcao: null
			},
			statusBusca: false

		};
	},
	mounted() {},
	watch: {
		observaBusca(novo, atual) {
			if (novo[0] || novo[1] || novo[2]) {
				// console.log('retorna busca')
				this.statusBusca = true
			}
		}
	},
	computed: {
		observaBusca() {
			if (this.$root.$store.state.idAreaLista != '' || this.$root.$store.state.idTema != '' || this.$root.$store.state.pesquisaPalavra != '') {
				this.statusBusca = true
			}
			else {
				this.statusBusca = false
			}
		}
	},
	methods: {
		novaConsulta() {
			this.$root.$store.state.abrirNovaConsulta = true
		},
		limparFiltros() {
			// console.log('limpa filtros')
			this.$root.$store.state.idAreaLista = ""
			this.$root.$store.state.idTema = ""
			this.$root.$store.state.pesquisaPalavra = ""
		}
	}
};